import React, { useEffect } from "react";
import {
  Route,
  Routes,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import useUserStore from "./utils/storeApp";
import AppRoutes from "./AppRoutes";
import "./assets/sass/AppPortal.min.css";
/*import Footer from "./components/shared/Footer";*/
//theme
import "primereact/resources/themes/lara-light-indigo/theme.css";
//core
import "primereact/resources/primereact.min.css";
//icons
import "primeicons/primeicons.css";

// "/emails" and the upload-related paths temporarily removed from this list, untied to a
// ticket, so other devs can test the Emails and Uploads modules on GCP through QA. Not for
// merge to master/Dev — CPPCON-1140 put them here deliberately; re-add before merging.
const gcpRestrictedPaths = [
  "/user-registration", "/registration-success", "/sys-admin-registration", "/success-sysadmin-registration",
  "/sent-message", "/received-message", "/download-status",
  "/delete-user-activity", "/mailbox-size", "/message-forwarding", "/user-activity", "/user-status", "/user-account-history",
];

const App = () => {
  const { SetSharedObject, userSession, backendTarget, setGcpFeatureUnavailable } = useUserStore((state) => ({
    SetSharedObject: state.SetSharedObject,
    userSession: state.userSession,
    backendTarget: state.backendTarget,
    setGcpFeatureUnavailable: state.setGcpFeatureUnavailable,
  }));
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const isGcpUser = !!userSession?.is_gcp_user || backendTarget === "gcp";

  useEffect(() => {
    if (isGcpUser && gcpRestrictedPaths.includes(location.pathname)) {
      setGcpFeatureUnavailable(true);
      navigate("/dashboard", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, isGcpUser]);

  useEffect(() => {
    if (window !== "undefined") {
      if (location.pathname === "/reset-password") {
        let ob = {
          UserId: searchParams.get("userId"),
          Code: searchParams.get("code"),
          Type: "ResetPassword",
        };
        SetSharedObject("ResetPasswordObj", ob);
        navigate("/reset-password");
      } else {
        let flag = false;
        AppRoutes.map((route, index) => {
          if (location.pathname === route.path) {
            flag = true;
          }
        });
        if (!flag && location.pathname !== "/webmail") {
          navigate("/request-not-found");
        }
      }
    }
  }, []);
  return (
    <div>
      <Routes>
        {AppRoutes.map((route, index) => {
          const { element, ...rest } = route;
          return <Route key={index} {...rest} element={element} />;
        })}
      </Routes>
    </div>
  );
};
export default App;
